<template>
  <div>
    <div class="right-share-modular">
      <div
        class="right-share-tar-modualr"
        style="position: relative"
        v-for="(item, index) in shareMenuList"
        :key="index"
      >
        <!-- <div :class="(activeIndex == index ? 'right-share-item active-share-item' : 'right-share-item')"
          @click="selectActiveShare(index)">
          <img v-if="activeIndex == index" class="share-icon" :src="item.icon2" alt="">
          <img v-else class="share-icon" :src="item.icon1" alt="">
        </div>
        <div class="share-item-list-modular" :style="absoluteTop" v-if="activeIndex == index && index != 4" >
          <div class="share-item" v-for="(item, index) in currShareItemList" :key="index">
            {{item}}
          </div>
        </div> -->
        <el-popover
          placement="left"
          width="50"
          trigger="hover"
          :disabled="popoverDisabled"
        >
          <div class="share-tar-moular">
            <div
              class="share-item"
              v-for="(item, index) in currShareItemList"
              :key="index"
            >
              {{ item }}
            </div>
            <div class="share-item" v-if="index == 1">
              <img
                src="../../assets/public/footer-icon-2-1.jpeg"
                alt=""
                srcset=""
              />
            </div>
          </div>
          <el-button
            slot="reference"
            style="border: 0; padding: 0; background: transparent; float: right"
          >
          <!-- @click="selectActiveShare(index)" -->
          <!-- @mousemove="index<4?selectActiveShare(index):''" -->
            <div
              :class="
                activeIndex == index
                  ? 'right-share-item active-share-item'
                  : 'right-share-item'
              "
              @mouseenter="selectActiveShare(index)"
              v-if="item.showFlag"
            >
              <img
                v-if="activeIndex == index"
                class="share-icon"
                :src="item.icon2"
                alt=""
              />
              <img v-else class="share-icon" :src="item.icon1" alt="" />
            </div>
            <div></div>
          </el-button>
        </el-popover>
      </div>
    </div>
    <!-- 在线客服 -->
    <div class="online-service-modular" v-if="activeIndex == 4">
      <div class="online-servic-header">
        <img
          class="service-face-icon"
          src="../../assets/public/service-face-icon.png"
          alt=""
        />
        <img
          class="close-icon"
          @click="closeOnline()"
          src="../../assets/public/close-icon.png"
          alt=""
        />
      </div>
      <div class="online-servic-body">
        <div
          class="record-item"
          v-for="(item, index) in chatRecord"
          :key="index"
        >
          <div class="servic-content-item" v-if="item.type == 1">
            <div class="servic-content-item-header">
              <span class="servic-content-item-name">{{ item.name }}</span>
              <span class="servic-content-item-date">{{ item.dateTime }}</span>
            </div>
            <div class="servic-content-item-body">
              <div class="servic-content-item-modualr">
                <img
                  class="left-horn-icon"
                  src="../../assets/public/left-horn-icon.png"
                  alt=""
                />
                <div class="content-item">{{ item.content }}</div>
              </div>
            </div>
          </div>
          <div class="user-content-item" v-if="item.type == 2">
            <div class="servic-content-item-header">
              <span class="servic-content-item-name">{{ item.name }}</span>
              <span class="servic-content-item-date">{{ item.dateTime }}</span>
            </div>
            <div class="user-content-item-body">
              <div class="servic-content-item-modualr">
                <img
                  class="right-horn-icon"
                  src="../../assets/public/right-horn-icon.png"
                  alt=""
                />
                <div class="content-item">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="online-servic-footer">
        <div class="opload-img-btn">
          <img class="img-icon" src="../../assets/public/img-icon.png" alt="" />
        </div>
        <el-input
          type="textarea"
          rows="3"
          class="problem-textarea"
          placeholder="很高兴为您服务，请描述您的问题"
          v-model="problemInput"
        ></el-input>
        <el-button class="send-brn">发送</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shareRight",
  data() {
    return {
      popoverDisabled: false, //popover弹窗禁止
      activeIndex: -1,
      shareMenuList: [
        {
          index: 1,
          showFlag: true,
          icon1: require("../../assets/public/qq-icon-1.png"),
          icon2: require("../../assets/public/qq-icon-2.png"),
        },
        {
          index: 2,
          showFlag: true,
          icon1: require("../../assets/public/weChat-icon-1.png"),
          icon2: require("../../assets/public/weChat-icon-2.png"),
        },
        {
          index: 3,
          showFlag: true,
          icon1: require('../../assets/public/s-icon-1.png'),
          icon2: require('../../assets/public/s-icon-2.png'),
        },
        {
          index: 4,
          showFlag: true,
          icon1: require("../../assets/public/mail-icon-1.png"),
          icon2: require("../../assets/public/mail-icon-2.png"),
        },
        // {
        //   index: 5,
        //   showFlag: true,
        //   icon1: require("../../assets/public/note-icon-1.png"),
        //   icon2: require("../../assets/public/note-icon-2.png"),
        // },
        // {
        //   index: 6,
        //   showFlag: true,
        //   icon1: require('../../assets/public/share-icon-1.png'),
        //   icon2: require('../../assets/public/share-icon-2.png'),
        // },
        {
          index: 7,
          showFlag: false,
          icon1: require("../../assets/public/up-arrow-icon.png"),
          icon2: require("../../assets/public/up-arrow-icon.png"),
        },
      ],
      chatRecord: [
        {
          type: 1,
          name: "锦格客服",
          dateTime: "13:44:44",
          content: "您好，请问有什么问题需要帮助？",
        },
        {
          type: 2,
          name: "",
          dateTime: "13:45:44",
          content: "买的多有优惠吗？",
        },
      ],
      problemInput: "", //现在客服-问题
      currShareItemList: [],
      shareItemList: {
        qq: [
          // 'twitter', 'linkedin', 'youtube', 'vk', 'instagram'
          "QQ：766089551",
        ],
        wechat: [
          // 'twitter', 'linkedin', 'youtube', 'vk', 'instagram'
        ],
        s: [
          "Skype：86+18865488893"
        ],
        email: [
          // 'twitter', 'linkedin', 'youtube', 'vk', 'instagram'
          // "Skype：账号86+18865488893",
          "email：ginkgoemads@gmail.com",
          // "Twitter:https://twitter.com/frank31167187",
          // "Instagram:https://www.instagram.com/ginkgoem_onlineshop/",
          // "Youtube:https://www.youtube.com/@ginkgoem2877",
        ],
        message: [
          "Skype：账号86+18865488893",
          "Twitter:https://twitter.com/frank31167187",
          "Instagram:https://www.instagram.com/ginkgoem_onlineshop/",
          "Youtube:https://www.youtube.com/@ginkgoem2877",
        ],
        share: ["twitter", "linkedin", "youtube", "vk", "instagram"],
      },
      absoluteTop: "top:100px;",
    };
  },
  methods: {
    // 选择
    selectActiveShare(index) {
      let that = this;
      // console.log(index)
      if (that.activeIndex == index) {
        that.activeIndex = -1;
      } else if (index == 4) {
        that.activeIndex = -1;
        that.popoverDisabled = true;
        // 返回顶部
        document.documentElement.scrollTop = 0;
      }
      // else if (index == 4) {
      //   that.activeIndex = index;
      //   that.popoverDisabled = true;
      // }
      else {
        that.activeIndex = index;
        that.getShowShareList(index);
        that.popoverDisabled = false;
      }
    },
    getShowShareList(index) {
      let that = this;
      switch (index) {
        case 0:
          // qq
          that.currShareItemList = that.shareItemList.qq;
          that.absoluteTop = "top:0px;";
          break;
        case 1:
          // wechat
          that.currShareItemList = that.shareItemList.wechat;
          that.absoluteTop = "top:10px;";
          break;
        case 2:
          // s
          that.currShareItemList = that.shareItemList.s;
          // email
          // that.currShareItemList = that.shareItemList.email;

          that.absoluteTop = "top:50px;";
          break;
        case 3:
          // email
          that.currShareItemList = that.shareItemList.email;
          that.absoluteTop = "top:120px;";
          break;
        case 5:
          // share
          that.currShareItemList = that.shareItemList.share;
          that.absoluteTop = "top:220px;";
          break;

        default:
          break;
      }
    },
    // 关闭在线弹窗
    closeOnline() {
      this.activeIndex = -1;
    },
    scrollToTop() {
      let that = this;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      let newData = that.shareMenuList[that.shareMenuList.length - 1];
      // 滚动大于200显示返回顶部按钮
      if (scrollTop > 200) {
        newData.showFlag = true;
        that.$set(that.shareMenuList, that.shareMenuList.length - 1, newData);
      } else if (scrollTop < 200) {
        newData.showFlag = false;
        that.$set(that.shareMenuList, that.shareMenuList.length - 1, newData);
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
};
</script>

<style lang="scss">
.right-share-modular {
  position: fixed;
  right: 0;
  // top: 65%;
  top: 52%;
  z-index: 10;

  .right-share-tar-modualr {
    position: relative;

    .right-share-item {
      cursor: pointer;
      width: 44px;
      height: 38px;
      background: #ffffff;
      border-top-left-radius: 19px;
      border-bottom-left-radius: 19px;
      margin-bottom: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 1px 1px 5px #999;
      float: right;

      .share-icon {
        width: 18px;
      }
    }

    .active-share-item {
      width: 59px;
    }
  }

  .share-item-list-modular {
    position: absolute;
    right: 70px;
    width: 110px;
    // height: 165px;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 1px 1px 5px #eee;
    padding: 5px;

    .share-item {
      padding: 5px;
    }
  }
}

// 在线客服
.online-service-modular {
  position: fixed;
  top: 45%;
  right: 5%;
  width: 360px;
  box-shadow: 1px 1px 5px #999;
  z-index: 10;

  .online-servic-header {
    height: 61px;
    background: #5e69ad;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 12px;

    .service-face-icon {
      width: 44px;
      height: 44px;
      border-radius: 50%;
    }

    .close-icon {
      width: 13px;
      cursor: pointer;
    }
  }

  .online-servic-body {
    background: #fafafa;
    border-radius: 6px 6px 0px 0px;
    height: 250px;

    .record-item {
      .servic-content-item {
        padding-top: 10px;
        padding-left: 18px;

        .servic-content-item-header {
          .servic-content-item-name,
          .servic-content-item-date {
            font-size: 13px;
            font-weight: 400;
            color: #999999;
          }

          .servic-content-item-date {
            margin-left: 5px;
          }
        }

        .servic-content-item-body {
          .servic-content-item-modualr {
            position: relative;

            .left-horn-icon {
              width: 9px;
              position: absolute;
              left: 0px;
              top: 10px;
            }

            .content-item {
              position: absolute;
              left: 8px;
              max-width: 250px;
              background: #e9f0ef;
              border-radius: 3px;
              font-size: 14px;
              font-weight: 400;
              color: #333333;
              padding: 12px;
            }
          }
        }
      }

      .user-content-item {
        padding-top: 60px;
        padding-right: 23px;

        .servic-content-item-header {
          text-align: right;

          .servic-content-item-name,
          .servic-content-item-date {
            font-size: 13px;
            font-weight: 400;
            color: #999999;
          }

          .servic-content-item-date {
            margin-left: 5px;
          }
        }

        .user-content-item-body {
          .servic-content-item-modualr {
            position: relative;

            .right-horn-icon {
              width: 9px;
              position: absolute;
              right: 0px;
              top: 10px;
            }

            .content-item {
              position: absolute;
              right: 8px;
              max-width: 250px;
              background: #5e69ad;
              border-radius: 3px;
              font-size: 14px;
              font-weight: 400;
              color: #ffffff;
              padding: 13px;
            }
          }
        }
      }
    }
  }

  .online-servic-footer {
    height: 124px;
    background: #ffffff;
    border: 1px solid #ededed;
    position: relative;

    .opload-img-btn {
      margin-top: 15px;
      margin-left: 12px;

      .img-ico {
        width: 17px;
        height: 15px;
      }
    }

    .problem-textarea textarea {
      resize: none;
      border: 0;
    }

    .send-brn {
      width: 49px;
      height: 27px;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 3px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 13px;
      bottom: 17px;
      padding: 0;
    }
  }
}

@media screen and (max-width: 500px) {
  .right-share-modular {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/publicRight.vue